import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Code,
  Heading,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const ApiBlockRequestParams = () => {
  const isUserLoggedIng = useSelector(
    (state: RootState) => state.userData.isUserLoggedIn
  );
  const usersApiKey = useSelector((state: RootState) => state.apiKey.apiKey);

  return (
    <div>
      <Heading size="md">Params</Heading>
      <Accordion allowMultiple mt={3} mb={5} defaultIndex={[0]}>
        <AccordionItem>
          <h2>
            <AccordionButton pl={0}>
              Authorization: Bearer Token
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} pl={0}>
            Provide your bearer token in the{" "}
            <Code colorScheme="teal">Authorization</Code> header when making
            requests to protected resources. <br />
            <br />
            <Code>
              Authorization: Bearer{" "}
              {isUserLoggedIng ? usersApiKey : "YOUR_API_KEY"}
            </Code>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default ApiBlockRequestParams;
